import React from 'react';
import moment from 'moment';
import jsonpath from 'jsonpath';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const DailyInitialFlowManagement = ({ pdfData = [], test = {}, data, company, id }) => {
  console.log(data, "sdcssdkc",test)
  function extractData(json, path) {
    const result = jsonpath.query(json, path);
    return result;
  }

  const getAllSamples = () => {
    let smaples = []
    pdfData.forEach((one) => {
      smaples = [...smaples, ...one.sampleRef]
    })
    return smaples
  }
  const checksheetdata = test.filter(one =>
    (one.InspectionType === 'IFM - Product - Msr' || one.InspectionType === 'IFM_Product_FBD') &&
    (one.DateTime.split('T')[0] === data.DateTime.split('T')[0]) &&
    one.Item === data.Item
    // one.customFields.find(field =>
    //     field.FieldName === 'Shift' &&
    //     field.Value[0] === extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value')[0]
    // )
  );



  const downloadPdf = (tableData) => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a3', // Setting A3 size
      compress:true,
    });
  
    const title = `Daily Initial Flow Management`;
  
    const tableHeaders = [
      // First row with Part Name, etc.
      [
        { content: `Part Name: `, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
        { content: `${data.Item}`, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
  
        { content: "DAILY INITIAL FLOW MANAGEMENT CONTROL ITEMS MONITORING CHECKSHEET ( PART )", colSpan: tableData.length == 0 ? 1 : tableData.length + 1, rowSpan: 4, styles: { halign: 'center', valign: 'middle', } },
        { content: `DATE: ${moment(data.DateTime).format('DD-MM-YYYY')}`, colSpan: 1, rowSpan: 4, styles: { halign: 'center', cellWidth: 13 ,cellPadding:1} }
      ],
      [
        { content: `Part No: `, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
        { content: `${data.ItemNumber}`, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
      ],
      // Second row for Model and Vendor
      [
        { content: `Model:`, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
        { content: `${extractData(data, '$..customFields[?(@.FieldName=="Model")].Value')}`, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
      ],
      [
        { content: `Vendor:`, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
        { content: ` ${extractData(data, '$..customFields[?(@.FieldName=="Vendor")].Value')}`, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
      ],
      // Third row for column names (S.No, Stage, etc.)
      [
        { content: 'S.No', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 8 ,cellPadding:1 } },
        { content: 'Stage', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
        { content: 'MISP Sr.No.', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 15 ,cellPadding:1} },
        { content: 'MISP Page No.', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 15 ,cellPadding:1} },
        { content: 'Control Items', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 23 ,cellPadding:1} },
        { content: 'Content', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 40,cellPadding:1 } },
        { content: 'Process Capability Applicable (Yes/No)', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 15,cellPadding:1 } },
        { content: 'CHECKING METHODS', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 15 ,cellPadding:1} },
        { content: 'Normal Frequency', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 15 ,cellPadding:1} },
        { content: 'IFM Frequency', rowSpan: 3, colSpan: 1, styles: { halign: 'center', cellWidth: 15 ,cellPadding:1} },
        { content: 'Result', colSpan: tableData.length <= 1 ? 1 : tableData.length + 1, rowSpan: 1, styles: { halign: 'center' ,cellPadding:1} }
      ],
      // Fourth row for the number of samples (dynamic)
      [
        ...tableData
          .sort((a, b) => new Date(a.DateTime) - new Date(b.DateTime)).map((_, index) => ({ content: `${_.sampleRef && _.sampleRef.length > 0
            ? _.sampleRef[0].Sample.split('Sample')[1]
            : "-"}`, rowSpan: 1, colSpan: 1, styles: { halign: 'center' ,cellPadding:1} }))
      ],
      // Fifth row for sample names (dynamic)
      [
        ...tableData.map((sample) => ({ content: extractData(sample, '$..customFields[?(@.FieldName=="Sample ID")].Value') || "-", rowSpan: 1, colSpan: 1, styles: { halign: 'center',cellPadding:1 } }))
      ],
    ];
    const tableFooter =[
      [ { content: 'Note - Making is Required on first 5000 Parts or for first 3 months whichever is earlier	', rowSpan: 1, colSpan: 3, styles: { halign: 'center' ,cellPadding:1} },
       { content: '', rowSpan: 1, colSpan: 7+ tableData.length, styles: { halign: 'center' ,cellPadding:1} },
      ],
      [
         { content: 'CHECKED BY', rowSpan: 1, colSpan: 3, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
       { content: `${extractData(data, '$..customFields[?(@.FieldName=="Checked By")].Value')}`, rowSpan: 1, colSpan: tableData.length+7, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
   
      ],
      [
        { content: 'VERIFIED BY', rowSpan: 1, colSpan: 3, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
      { content: '', rowSpan: 1, colSpan: tableData.length+7, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
  
     ],
     [
      { content: 'APPROVED', rowSpan: 1, colSpan: 3, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
    { content: '', rowSpan: 1, colSpan: tableData.length+7, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },

   ],
   [
    { content: 'REMARKS', rowSpan: 1, colSpan: 3, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
  { content: `${getString(tableData)}`, rowSpan: 1, colSpan: tableData.length+7, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },

 ]
      ]
    // AutoTable settings with adjusted margins and layout for A3
    doc.autoTable({
      head: tableHeaders,
      body: data.Checksheet.map((one) => [
        one.SNO,
        one.Stage,
        one.MISP_SrNo,
        one.MISP_Page_No,
        one.Control_Items,
        one.Content,
        "", // Process Capability Applicable
        one.Checking_Methods,
        one.Normal_Frequency,
        one.IFM_Frequency,
        ...tableData.map((_, index) => (_.Checksheet[index] && _.Checksheet[index].StandardType === 'Dimension' ? _.Checksheet[index].Data[0] && _.Checksheet[index].Data[0].Observed_Value : _.Checksheet[index].Data[0] && _.Checksheet[index].Data[0].Result)),
      ]),
      foot:tableFooter,
      startY: 20,
      theme: 'striped',
      styles: {
        fontSize: 8,
        cellPadding: 2,
        lineWidth: 0.1, // Border width
        lineColor: [0, 0, 0], // Border color (black)
      },
      headStyles: {
        fillColor: [255, 255, 255], // Header background color
        textColor: [0, 0, 0], // Header text color
        lineWidth: 0.1, // Header border width
        lineColor: [0, 0, 0], // Header border color (black)
      },footStyles: {
        fillColor: [255, 255, 255], // Set to white to remove the background color of the footer
        textColor: [0, 0, 0], // Keep text color black
        lineWidth: 0.1, // Footer border width (same as rest of the table)
        lineColor: [0, 0, 0], // Footer border color
    },
      margin: { top: 2, right: 5, bottom: 5, left: 5 }, // Adjusted margins for A3 sheet
      didDrawPage: (data) => {
        doc.text(`Page ${doc.internal.getNumberOfPages()}`, data.settings.margin.left, doc.internal.pageSize.height - 2);
      },
    });
  
    doc.save('DailyInitialFlowManagement_A3.pdf');
  };
  
  const chunkArray = (array, size) => {
    console.log(array,"lfjidj")
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const getString = (tableData) => {
    const string = []
    data.Checksheet.forEach((one, index) => (
      tableData
        .forEach((_, idx) => {
          if (_.Checksheet && _.Checksheet[index] && _.Checksheet[index].Data && _.Checksheet[index].Data[0] && _.Checksheet[index].Data[0].Remarks) {
            string.push(_.Checksheet[index].Data[0].Remarks)
          }
        })
    ))
    return string.join(', ');
  }

  // Split the checksheetdata into chunks of 10
  const chunkedChecksheetData = chunkArray(checksheetdata, 10);
  const renderTable = (tableData, tableIndex) => (
    <>
      {console.log(tableData, "vdivdf")}

      <button className="btn btn-primary mb-3" onClick={() => downloadPdf(tableData)}>Download PDF</button>
      <div>
        <table
          className="table table-sm table-bordered table-hover small table-striped"
          style={{ padding: 0 }}
          key={tableIndex}
        >
          <thead className='small text-center border'>
            <tr className='text-center align-self-center '>
              <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Part Name :</th>
              <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{data.Item}</th>

              <th style={{ verticalAlign: 'middle' }} className='fs-6' rowSpan={4} colSpan={tableData.length + 1}> DAILY INITIAL FLOW MANAGEMENT CONTROL ITEMS MONITORING CHECKSHEET ( PART )</th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={4} colSpan={1}> DATE - {moment(data.DateTime).format('DD-MM-YYYY')}</th>
            </tr>
            <tr className='text-center align-self-center '>
              <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Part No :</th>
              <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{data.ItemNumber}</th>
            </tr>
            <tr className='text-center align-self-center '>
              <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Model :</th>
              <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{extractData(data, '$..customFields[?(@.FieldName=="Model")].Value')}</th>
            </tr>
            <tr className='text-center align-self-center '>
              <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Vendor :</th>
              <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{extractData(data, '$..customFields[?(@.FieldName=="Vendor")].Value')}</th>
            </tr>
            <tr className='text-center align-self-center '>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3} >S.No</th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3} >Stage</th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3}  >MISP Sr.No.</th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3}  >MISP Page No.</th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3} >Control Items</th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3} >Content</th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3} >Process Capability Applicable (Yes /No)</th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3} >CHECKING METHODS </th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3} >Normal Frequency </th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={3} >IFM Frequency </th>
              <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={tableData.length}>Result</th>


            </tr>
            <tr className='text-center align-self-center '>
              {/* {tableData.map((_, index) => <>
          <th style={{ verticalAlign: 'middle' }} rowSpan={1} >{index + 1}</th>
        </>)} */}
              {tableData
                .sort((a, b) => new Date(a.DateTime) - new Date(b.DateTime)) // Correct sorting by DateTime
                .map((item, index) => (
                  <th className='text-wrap' key={index} style={{ verticalAlign: 'middle' }} rowSpan={1}>
                    {item.sampleRef && item.sampleRef.length > 0
                      ? item.sampleRef[0].Sample.split('Sample')[1]
                      : "-"}
                  </th>
                ))}
            </tr>
            <tr className='text-center align-self-center '>
              {tableData
                .sort((a, b) => new Date(a.DateTime) - new Date(b.DateTime)).map((item, index) => <>
                  <th style={{ verticalAlign: 'middle' }} rowSpan={1} >{extractData(item, '$..customFields[?(@.FieldName=="Sample ID")].Value') || "-"}</th>
                </>)}
            </tr>
          </thead>
          <tbody>

            {data.Checksheet.map((one, index) => <tr >


              <th style={{ fontWeight: '400' }} className="text-center">{one.SNO}</th>
              <th style={{ fontWeight: '400' }} className="text-center">{one.Stage}</th>
              <th style={{ fontWeight: '400' }} className="text-center">{one.MISP_SrNo}</th>
              <th style={{ fontWeight: '400' }} className="text-center">{one.MISP_Page_No}</th>
              <th className="text-center" style={{ fontWeight: '400' }}>{one.Control_Items}</th>
              <th className="text-center" style={{ fontWeight: '400' }}>{one.Content}</th>
              <th className="text-center" style={{ fontWeight: '400' }}></th>
              <th className="text-center" style={{ fontWeight: '400' }}>{one.Checking_Methods}</th>


        <th className="text-center" style={{ fontWeight: '400' }}>{one.Normal_Frequency}</th>
        <th className="text-center" style={{ fontWeight: '400' }}>{one.IFM_Frequency}</th>
        {/* {tableData.map((item, index) => <th className="text-center" style={{ verticalAlign: 'middle' }} rowSpan={1} >{item.Value || ""}</th>)} */}
        {/* {tableData.map((_, idx) => (
                                    <th key={idx} className="text-center">{_.Checksheet[index] &&  _.Checksheet[index].StandardType=='Dimension'? _.Checksheet[index].Data.length > 0 ?(_.Checksheet[index].Data.map(idx=>idx.Observed_Value) +' / ' + _.Checksheet[index].Data.map(idx=>idx.Result) ): '-'  : _.Checksheet[index].Data.length > 0 ? _.Checksheet[index].Data.map(idx=>idx.Result) : '-'}</th>
                                ))} */}
                                {tableData.map((_, idx) => (
                <th key={idx} className="text-center">{_.Checksheet[index] && _.Checksheet[index].Data[0] ? _.Checksheet[index].Data[0].Result : '-'}</th>
              ))}

      </tr>)}



          </tbody>
          <tfoot className='small text-center border'>
            <tr className='text-center align-self-center '>
              <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={3}>Note - Making is Required on first 5000 Parts or for first 3 months whichever is earlier</td>
              <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length + 6}></td>
            </tr>
            <tr className='text-center align-self-center '>
              <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={3}>CHECKED BY</td>
              <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length + 6}>{extractData(data, '$..customFields[?(@.FieldName=="Checked By")].Value')}</td>


            </tr> <tr className='text-center align-self-center '>
              <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={3}>VERIFIED BY</td>
              <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length + 6}></td>


            </tr> <tr className='text-center align-self-center '>
              <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={3}>APPROVED</td>
              <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length + 6}></td>


            </tr> <tr className='text-center align-self-center '>
              <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={3}>REMARKS</td>
              <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length + 6}>




                {getString(tableData)}


              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </>
  );

  return (
    <div>{console.log(chunkedChecksheetData, "vkjbvdk")}
      {/* Render tables dynamically based on chunks */}
      <button
  className="btn-primary btn-sm mx-1"
  onClick={() => {
    chunkedChecksheetData.forEach((tableData, index) => {
      setTimeout(() => {
        downloadPdf(tableData);
      }, index * 3000); // 3 seconds delay for each download
    });
  }}
>
  Download All
</button>

      {chunkedChecksheetData.map((tableData, index) => (
        renderTable(tableData, index)
      ))}
    </div>
  );
};

export default DailyInitialFlowManagement;
